import { Plug2, Circle } from 'lucide-react';
import { useSessionStore } from '../store/sessionStore';
import './TopBar.css';

export function TopBar() {
  const { events, connectionStatus, unacknowledgedAlerts } = useSessionStore();
  const isLive = connectionStatus === 'live';
  const isReconnecting = connectionStatus === 'reconnecting';
  const activeAlerts = unacknowledgedAlerts.length;

  const statusLabel =
    connectionStatus === 'live'
      ? 'Connected'
      : connectionStatus === 'reconnecting'
      ? 'Reconnecting…'
      : 'Disconnected';

  const statusColor =
    connectionStatus === 'live'
      ? 'var(--accent-green)'
      : connectionStatus === 'reconnecting'
      ? 'var(--accent-amber)'
      : 'var(--accent-red)';

  return (
    <header className="topbar">
      <div className="topbar-left">
        <Plug2 size={16} className="topbar-logo-icon" />
        <span className="topbar-title">Multi-Agent Debugger</span>
      </div>

      <div className="topbar-center">
        {isLive && (
          <div className="topbar-live-badge">
            <span className="live-dot" />
            LIVE
          </div>
        )}
      </div>

      <div className="topbar-right">
        {activeAlerts > 0 && (
          <div className="topbar-stat topbar-alert">
            <span className="topbar-stat-value">
              <Circle size={7} fill="var(--accent-red)" color="var(--accent-red)" />
              {activeAlerts}
            </span>
            <span className="topbar-stat-label">alert{activeAlerts !== 1 ? 's' : ''}</span>
          </div>
        )}

        <div className="topbar-stat">
          <span className="topbar-stat-value">{events.length}</span>
          <span className="topbar-stat-label">events</span>
        </div>

        <div className="topbar-connection">
          <Circle
            size={7}
            fill={statusColor}
            color={statusColor}
            className={isReconnecting ? 'pulse' : ''}
          />
          <span
            className="topbar-status-label"
            style={{ color: statusColor }}
          >
            {statusLabel}
          </span>
        </div>
      </div>
    </header>
  );
}
